import { useState, useEffect, useCallback } from 'react';
import { GridWithPagination } from '../../common/GridWithPagination/GridWithPagination';
import { Campaign, campaignsQueryParams } from '../../types/campaign';

interface searchParams {
    searchBarValue: string;
    dataFetchFunction: (params: campaignsQueryParams) => Promise<Campaign[]>;
    params
}

const getMatchedSearchItems = (items: Campaign[], searchValue: string) =>
    items.filter(
        (item) =>
            item.promotion_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.promotion_id?.toLowerCase().includes(searchValue.toLowerCase())
    );

export default function Campaigns({ searchBarValue, dataFetchFunction, params }: searchParams): JSX.Element {
    const [dataToDisplay, setDataToDisplay] = useState<Campaign[]>([]);

    const fetchCampaigns = useCallback(() => {
        dataFetchFunction(params).then((fetchedData: Campaign[]) =>
            setDataToDisplay(getMatchedSearchItems(fetchedData, searchBarValue))
        )
    }, [dataFetchFunction, params, searchBarValue])

    useEffect(() => {
        fetchCampaigns();
    }, [fetchCampaigns]);

    return <GridWithPagination gridData={dataToDisplay} refetchCampaigns={fetchCampaigns} />;
}

export { Campaigns };
